import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  TextField,
  Box,
} from '@mui/material';
import { DriverCheckin } from '../types';

interface ModalFinishCheckinProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (observation: string | null) => void;
  driver: DriverCheckin;
}

const ModalFinishCheckin: React.FC<ModalFinishCheckinProps> = ({
  open,
  onClose,
  onConfirm,
  driver,
}) => {
  const [addObservation, setAddObservation] = useState(false);
  const [observation, setObservation] = useState('');

  const handleConfirm = () => {
    const finalObservation = addObservation ? observation.trim() : null;
    onConfirm(finalObservation);
    setAddObservation(false);
    setObservation('');
  };

  const handleClose = () => {
    onClose();
    setAddObservation(false);
    setObservation('');

  };


  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="finish-dialog-title"
      aria-describedby="finish-dialog-description"
    >
      <DialogTitle id="finish-dialog-title">{"Confirmar Finalização"}</DialogTitle>

      <DialogContent>
        <DialogContentText id="finish-dialog-description" sx={{ mb: 2 }}>
          Tem certeza que deseja finalizar o atendimento para {driver.driver_name} (Placa: {driver.license_plate})?
        </DialogContentText>

        <FormControlLabel
          control={
            <Checkbox
              checked={addObservation}
              onChange={(e) => setAddObservation(e.target.checked)}
              name="addObservation"
              color="primary"
            />
          }

          label="Adicionar Observação"
        />

        {addObservation && (
          <Box sx={{ mt: 2 }}>
            <TextField

              autoFocus
              margin="dense"
              id="observation"
              label="Observação"
              type="text"
              fullWidth
              multiline
              rows={3}
              variant="outlined"

              value={observation}
              onChange={(e) => setObservation(e.target.value)}

            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Não</Button>
        <Button onClick={handleConfirm} autoFocus color="success">Sim, Finalizar</Button>

      </DialogActions>
    </Dialog>
  );
};

export default ModalFinishCheckin;
